import Address from '@/components/Address';
import Amount from '@/components/Amount';
import OrderStatus from '@/components/OrderStatus';
import { SwapTxType } from '@/constants';
import { ShareIcon } from '@bfe/moly-icons';
import { useFm } from '@web3/base-hooks';
import { useSwapChainList } from '../hooks';
import { SwapOrderDetail } from '@/services/swap';

interface Props {
  data: SwapOrderDetail[];
}

export function OrderDetail({ data }: Props) {
  const t = useFm();

  const { getBaseTokenName } = useSwapChainList();

  const SwapTxTypeLabel = {
    [SwapTxType.approval]: t('approve'),
    [SwapTxType.aChainTransfer]: t('swap'),
    [SwapTxType.bChainTransfer]: t('swap'),
    [SwapTxType.aChainRefund]: t('Refund'),
  };

  return (
    <table className="w-full bg-bds-gray-ele-edge">
      <thead>
        <tr className="text-left text-bds-gray-t2 text-xs">
          <th className="p-3">{t('tradeType')}</th>
          <th className="p-3">{t('chain')}</th>
          <th className="p-3">{t('from')}</th>
          <th className="p-3">{t('to')}</th>
          <th className="p-3">{t('gasFee')}</th>
          <th className="p-3">{t('status')}</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td className="p-3">
              <div className="inline-flex flex-col gap-0.5">
                <p className="text-sm font-medium">
                  <span>{SwapTxTypeLabel[row.type]}</span>&nbsp;
                  <span>
                    {+row.type === SwapTxType.bChainTransfer
                      ? row.toTokenSymbol
                      : row.fromTokenSymbol}
                  </span>
                </p>
                {row.txHash && (
                  <a
                    className="text-xs text-bds-gray-t2 inline-flex items-center gap-0.5 hover:text-[#9747ff]"
                    href={`${row.txExplorerUrl}${row.txHash}`}
                    target="_blank"
                  >
                    <span>
                      {row.txHash.replace(/(.{6}).*(.{4})/, `$1...$2`)}
                    </span>
                    <ShareIcon className="size-3" />
                  </a>
                )}
              </div>
            </td>
            <td className="p-3">
              <div className="flex items-center gap-1">
                <img src={row.chainIconUrl} alt="chain" className="size-4" />
                <span className="text-xs font-medium">{row.chainName}</span>
              </div>
            </td>
            <td className="p-3">
              <Address
                address={row.fromAddress}
                className="text-xs text-bds-gray-t2"
              />
            </td>
            <td className="p-3">
              <Address
                address={row.toAddress}
                className="text-xs text-bds-gray-t2"
              />
            </td>
            <td className="p-3 text-xs font-medium">
              <Amount
                amount={row.actualGasFeeAmount}
                symbol={getBaseTokenName(row.chainId)}
              />
            </td>
            <td className="p-3">
              <OrderStatus status={row.status} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
